import angular from 'angular';

import accountService from '../../services/account.service.js';
import authenticationService from '../../services/authentication.service.js';
import userlinkingService from '../../services/userlinking.service.js';

import activeLoansController from './activeLoans.controller.js';
import activeLoansItemController from './activeLoansItem.controller.js';
import closedLoansController from './closedLoans.controller.js';
import closedLoansItemController from './closedLoansItem.controller.js';
import requestsController from './requests.controller.js';
import requestsItemController from './requestsItem.controller.js';
import userlinkingController from './userlinking.controller.js';
import userlinkingCreateController from './userlinkingCreate.controller.js';
import userlinkingCreateModalController from './userlinkingCreateModal.controller.js';
import userlinkingDeleteController from './userlinkingDelete.controller.js';
import userlinkingDeleteModalController from './userlinkingDeleteModal.controller.js';

export default angular.module('components.lk', [accountService, authenticationService, userlinkingService])
    .component('userlinking', {
        template: require('./userlinking.pug')(),
        controller: userlinkingController
    })
    .component('userlinkingCreate', {
        template: require('./userlinkingCreate.pug')(),
        bindings: {
            text: '@',
            onDone: '&'
        },
        controller: userlinkingCreateController
    })
    .component('userlinkingCreateModal', {
        template: require('./userlinkingCreateModal.pug')(),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }, 
        controller: userlinkingCreateModalController
    })
    .component('userlinkingDelete', {
        template: require('./userlinkingDelete.pug')(),
        bindings: {
            text: '@',
            database: '<',
            onDone: '&'
        },
        controller: userlinkingDeleteController
    })
    .component('userlinkingDeleteModal', {
        template: require('./userlinkingDeleteModal.pug')(),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }, 
        controller: userlinkingDeleteModalController
    })
    .component('activeLoans', {
        template: require('./activeLoans.pug')(),
        controller: activeLoansController 
    })
    .component('activeLoansItem', {
        bindings: {
            item: '<',
            onSelect: '&'
        },
        template: require('./activeLoansItem.pug')(),
        controller: activeLoansItemController
    })
    .component('closedLoans', {
        template: require('./closedLoans.pug')(),
        controller: closedLoansController
    })
    .component('closedLoansItem', {
        bindings: {
            catalogid: '@',
            item: '<',
            onSelect: '&'
        },
        template: require('./closedLoansItem.pug')(),
        controller: closedLoansItemController
    })
    .component('requests', {
        template: require('./requests.pug')(),
        controller: requestsController,
    })
    .component('requestsItem', {
        bindings: {
            catalogid: '@',
            item: '<',
            onSelect: '&'
        },
        template: require('./requestsItem.pug')(),
        controller: requestsItemController
    })
    .component('patronInfo', {
        //bindings: {
        //},
        template: require('./patronInfo.pug')(),
        controller: ['AccountService', 'LKConfig', function(AccountService, LKConfig) {
            var ctrl = this;

            ctrl.$onInit = function() {
                console.log('onInit()');
                ctrl.load();
            };

            ctrl.load = function() {
                var params = {};
                params.cat = 'userinfo';
                AccountService.get(params).$promise.then(function(response) {
                    ctrl.response = response;
                }, function(err) {
                    ctrl.error = err.message | err;
                });
            };

        }]
    })
    .value('LKConfig', {
        catalogid: 1,
        maxSize: 10,
        hitsList: [
            {name: '1', value: 1},
            {name: '5', value: 5},
            {name: '10', value: 10},
            {name: '20', value: 20}
        ],
        itemsPerPage: 5,
        itemsPerPageList: [
            1, 5, 10, 20, 50
        ],
        archiveDatabasesList: [
            {name: 'Архив за 2022 г.', value: 'acirc2022'},
            {name: 'Архив за 2021 г.', value: 'acirc2021'},
            {name: 'Архив за 2020 г.', value: 'acirc2020'},
            {name: 'Архив за 2019 г.', value: 'acirc2019'},
            {name: 'Архив за 2018 г.', value: 'acirc2018'},
            {name: 'Архив за 2017 г.', value: 'acirc2017'},
            {name: 'Архив за 2016 г.', value: 'acirc2016'},
            {name: 'Архив за 2015 г.', value: 'acirc2015'},
            {name: 'Архив за 2014 г.', value: 'acirc2014'}
        ]
    })
    .filter('grs1_val', function() {
        return function(input, tag) {
            input = input || '';
            let out = '';
            let dlm = ',';
            if (tag) {
                for (var i = 0; i<input.length; i++) {
                    if (input[i].tag === tag) {
                        if (out!='') out+= dlm;
                        out += input[i].data;
                    }
                }
            }
            return out;
        };
    })
 
    .filter('grs1_date', function() {
        return function(input) {
            let out = '';
            if (input) {
                var yyyy = input.substring(0, 4);
                var MM = input.substring(4, 6);
                var dd = input.substring(6, 8);
                var hh = input.substring(8, 10)||'00';
                var mm = input.substring(10, 12)||'00';
                var ss = input.substring(12, 14)||'00';
                out = yyyy+MM+dd+'T'+hh+mm+ss+'Z';
            }
            return out;
        };
    })
    .filter('getOrderStatusByCode', function() {
        var orderstatus = [
            {code: '0', value:__('In progress')},
            {code: '1', value:__('Completed')},
            {code: '2', value:__('Document is loaned')},
            {code: '3', value:__('Rejected')}
        ];
        return function(input) {
            for (var i in orderstatus) {
                if (orderstatus[i].code === input) {
                    return orderstatus[i].value;
                }
            }
            return input;
        };
    })
    .name; 
